var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDrop(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 8.86",
    fill: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12,2a14.911,14.911,0,0,0-4.6.72v3.1a1.008,1.008,0,0,1-.56.9A11.511,11.511,0,0,0,4.18,8.57a.982.982,0,0,1-.7.28,1,1,0,0,1-.71-.29L.29,6.08A.956.956,0,0,1,0,5.38a1,1,0,0,1,.29-.71,17.016,17.016,0,0,1,23.42,0,1.014,1.014,0,0,1,0,1.42L21.23,8.57a1,1,0,0,1-.71.29,1.026,1.026,0,0,1-.7-.28,11.27,11.27,0,0,0-2.67-1.85,1,1,0,0,1-.56-.9V2.73A14.516,14.516,0,0,0,12,2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrop);
export default __webpack_public_path__ + "static/media/Drop.06c6811dc3f466efeac97c94bb2689b3.svg";
export { ForwardRef as ReactComponent };